import React from 'react'
import { SidebarModal } from "kh-design-system/components"
import TaskStatusUpdate from './TaskStatusUpdate'
import CommentAndHistoryTabs from './CommentAndHistoryTabs';
import { dashboardColors, theme } from '../../themes/Theme';


const TaskSidebarModal = ({ openModal, setOpenModal, data, exhibitorId, taskId, particularTaskDetails, taskType }) => {

  const filterTaskId = taskId ? taskId : data?.task_id;
  const filterTaskType = particularTaskDetails?.taskType ? particularTaskDetails?.taskType : data?.task_type;
  const filterExhibitorId = exhibitorId ? exhibitorId : data?.exhibitor_id;
  const filterTitle = particularTaskDetails?.title ? particularTaskDetails?.title : data?.title;
  const filterDescription = particularTaskDetails?.description ? particularTaskDetails?.description : data?.description;
  const filterTaskColumnMapping = particularTaskDetails?.taskColumnMapping ? particularTaskDetails?.taskColumnMapping : data?.task_column_mapping;
  const assignmentId = data?.assignment_id

  const sectionText = {
    sectionTitleText: "Review and update",
    containerWidth: "530px",
    iconHeight: "24px",
    iconWidth: "24px",
    titleHeight: "50px",
    textColor: "white",
    backgroundColor: dashboardColors[theme].primary
  }


  return (
    <div>
      <SidebarModal
        backgroundColor={sectionText.backgroundColor}
        containerWidth={sectionText.containerWidth}
        iconHeight={sectionText.iconHeight}
        iconWidth={sectionText.iconWidth}
        setShow={setOpenModal}
        show={openModal}
        textColor={sectionText.textColor}
        title={sectionText.sectionTitleText}
        titleHeight={sectionText.titleHeight}
        children={<>
          <div className='top-section'>
            <TaskStatusUpdate
              data={data}
              exhibitorId={filterExhibitorId}
              filterTaskId={filterTaskId}
              filterTitle={filterTitle}
              filterDescription={filterDescription}
              filterTaskColumnMapping={filterTaskColumnMapping}
              filterTaskType={filterTaskType}
            />
          </div>
          <div className='bottom-section'>
            <CommentAndHistoryTabs assignmentId={assignmentId} taskId={filterTaskId} exhibitorId={filterExhibitorId} />
          </div>
        </>}
      />
      <style jsx>{`
        .top-section {
          height: 50%;
          overflow: auto;
        }
        .bottom-section {
          height: 50%;
          overflow: auto;
          border-top: 1px solid #ADB6BF;
        }
      `}</style>
    </div>
  )
}

export default TaskSidebarModal